import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="mt-16 border-t border-pink-100 bg-white/80 backdrop-blur">
            <div className="max-w-5xl mx-auto px-4 py-8 text-center text-sm text-slate-600 space-y-3">
                <p>© {new Date().getFullYear()} UnicorNation&reg; All rights reserved.</p>

                <div className="flex flex-wrap justify-center gap-4">
                    <Link to="/privacy" className="hover:text-pink-500 transition">
                        Privacy Policy
                    </Link>
                    <Link to="/terms" className="hover:text-pink-500 transition">
                        Terms of Service
                    </Link>
                    <Link
                        to="/advertising-disclosure"
                        className="hover:text-pink-500 transition"
                    >
                        Advertising Disclosure
                    </Link>
                </div>

                <p className="text-xs text-slate-500">
                    Some links and banners on this site may be sponsored or affiliate
                    links. UnicorNation is an event listing service only and does not run
                    or manage the events displayed.
                </p>
            </div>
        </footer>
    );
}
